import { createSelector } from '@ngrx/store';
import { FlowTypes } from '@shared/models';

import { selectTriageState } from '../triage/triage.selectors';
import { selectGiftingReceiptData } from './gifting/gifting-receipt.selectors';
import { selectInheritanceReceiptData } from './inheritance/inheritance-receipt.selectors';
import { selectMinorReceiptData } from './minor-transfer/minor-transfer-receipt.selectors';

export const selectReceiptData = createSelector(
  selectTriageState,
  selectInheritanceReceiptData(),
  selectMinorReceiptData(),
  selectGiftingReceiptData(true),
  (triage, inheritance, minor, gifting) => {
    switch (triage.flowType) {
      case FlowTypes.INHERITANCE:
        return inheritance;
      case FlowTypes.MINOR:
        return minor;
      case FlowTypes.GIFTING:
        return gifting;
    }
  },
);
